export const FETCH_CHATS = 'chatActions/FETCH_CHATS';
export const FETCH_CHATS_SUCCESS = 'chatActions/FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAILED = 'chatActions/FETCH_CHATS_FAILURE';

export const ADD_MESSAGE = 'chatActions/ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'chatActions/ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_FAILED = 'chatActions/ADD_MESSAGE_FAILURE';

export const FETCH_HISTORY = 'chatActions/FETCH_HISTORY';
export const FETCH_HISTORY_SUCCESS = 'chatActions/FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_FAILED = 'chatActions/FETCH_HISTORY_FAILURE';

export const CHANGE_STATE = 'chatActions/CHANGE_STATE';

export const FETCH_FOLDER_CHATS = 'chatActions/FETCH_FOLDER_CHATS';
export const FETCH_FOLDER_CHATS_SUCCESS =
  'chatActions/FETCH_FOLDER_CHATS_SUCCESS';
export const FETCH_FOLDER_CHATS_FAILED =
  'chatActions/FETCH_FOLDER_CHATS_FAILURE';

export const FETCH_FOLDER_CHANGES = 'chatActions/FETCH_FOLDER_CHANGES';
export const FETCH_FOLDER_CHANGES_SUCCESS =
  'chatActions/FETCH_FOLDER_CHANGES_SUCCESS';
export const FETCH_FOLDER_CHANGES_FAILED =
  'chatActions/FETCH_FOLDER_CHANGES_FAILURE';

export const ADD_FOLDER_MESSAGE = 'chatActions/ADD_FOLDER_MESSAGE';
export const ADD_FOLDER_MESSAGE_SUCCESS =
  'chatActions/ADD_FOLDER_MESSAGE_SUCCESS';
export const ADD_FOLDER_MESSAGE_FAILED =
  'chatActions/ADD_FOLDER_MESSAGE_FAILURE';

export const FETCH_PARTNER_CHATS = 'chatActions/FETCH_PARTNER_CHATS';
export const FETCH_PARTNER_CHATS_SUCCESS =
  'chatActions/FETCH_PARTNER_CHATS_SUCCESS';
export const FETCH_PARTNER_CHATS_FAILED =
  'chatActions/FETCH_FOLDER_CHATS_FAILURE';

export const ADD_PARTNER_MESSAGE = 'chatActions/ADD_PARTNER_MESSAGE';
export const ADD_PARTNER_MESSAGE_SUCCESS =
  'chatActions/ADD_PARTNER_MESSAGE_SUCCESS';
export const ADD_PARTNER_MESSAGE_FAILED =
  'chatActions/ADD_PARTNER_MESSAGE_FAILURE';

export const FETCH_COMPANY_CHATS = 'chatActions/FETCH_COMPANY_CHATS';
export const FETCH_COMPANY_CHATS_SUCCESS =
  'chatActions/FETCH_COMPANY_CHATS_SUCCESS';
export const FETCH_COMPANY_CHATS_FAILED = 'chatActions/FETCH_CHATS_FAILURE';

export const ADD_COMPANY_MESSAGE = 'chatActions/ADD_COMPANY_MESSAGE';
export const ADD_COMPANY_MESSAGE_SUCCESS =
  'chatActions/ADD_COMPANY_MESSAGE_SUCCESS';
export const ADD_COMPANY_MESSAGE_FAILED =
  'chatActions/ADD_COMPANY_MESSAGE_FAILURE';

export const EDIT_MESSAGE = 'chatActions/EDIT_MESSAGE';
export const EDIT_MESSAGE_SUCCESS = 'chatActions/EDIT_MESSAGE_SUCCESS';
export const EDIT_MESSAGE_FAILED = 'chatActions/EDIT_MESSAGE_FAILURE';

export const DELETE_MESSAGE = 'chatActions/DELETE_MESSAGE';
export const DELETE_MESSAGE_SUCCESS = 'chatActions/DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILED = 'chatActions/DELETE_MESSAGE_FAILURE';

export function fetchChats(postId, clear) {
  return {
    type: FETCH_CHATS,
    postId,
    clear,
  };
}

export function fetchChatsSuccess(chats) {
  return {
    type: FETCH_CHATS_SUCCESS,
    chats,
  };
}

export function fetchChatsFailed(err) {
  return {
    type: FETCH_CHATS_FAILED,
    err,
  };
}

export function addMessage(details, tempId) {
  return {
    type: ADD_MESSAGE,
    details,
    tempId,
  };
}

export function addMessageSuccess(chat, tempId) {
  return {
    type: ADD_MESSAGE_SUCCESS,
    chat,
    tempId,
  };
}

export function addMessageFailed(err) {
  return {
    type: ADD_MESSAGE_FAILED,
    err,
  };
}

export function fetchHistory(postId) {
  return {
    type: FETCH_HISTORY,
    postId,
  };
}

export function fetchHistorySuccess(history) {
  return {
    type: FETCH_HISTORY_SUCCESS,
    history,
  };
}

export function fetchHistoryFailed(err) {
  return {
    type: FETCH_HISTORY_FAILED,
    err,
  };
}

export function fetchFolderChats(folderId) {
  return {
    type: FETCH_FOLDER_CHATS,
    folderId,
  };
}

export function fetchFolderChatsSuccess(chats) {
  return {
    type: FETCH_FOLDER_CHATS_SUCCESS,
    chats,
  };
}

export function fetchFolderChatsFailed(err) {
  return {
    type: FETCH_FOLDER_CHATS_FAILED,
    err,
  };
}

export function addFolderMessage(folderId, details, tempId) {
  return {
    type: ADD_FOLDER_MESSAGE,
    details,
    folderId,
    tempId,
  };
}

export function addFolderMessageSuccess(chat, tempId) {
  return {
    type: ADD_FOLDER_MESSAGE_SUCCESS,
    chat,
    tempId,
  };
}

export function addFolderMessageFailed(err) {
  return {
    type: ADD_FOLDER_MESSAGE_FAILED,
    err,
  };
}

export function fetchParnerChats(postId) {
  return {
    type: FETCH_PARTNER_CHATS,
    postId,
  };
}

export function fetchParnerChatsSuccess(chats) {
  return {
    type: FETCH_PARTNER_CHATS_SUCCESS,
    chats,
  };
}

export function fetchParnerChatsFailed(err) {
  return {
    type: FETCH_PARTNER_CHATS_FAILED,
    err,
  };
}

export function addPartnerMessage(postId, details, tempId) {
  return {
    type: ADD_PARTNER_MESSAGE,
    details,
    postId,
    tempId,
  };
}

export function addPartnerMessageSuccess(chat, tempId) {
  return {
    type: ADD_PARTNER_MESSAGE_SUCCESS,
    chat,
    tempId,
  };
}

export function addPartnerMessageFailed(err) {
  return {
    type: ADD_PARTNER_MESSAGE_FAILED,
    err,
  };
}

export function fetchCompanyChats(companyId) {
  return {
    type: FETCH_COMPANY_CHATS,
    companyId,
  };
}

export function fetchCompanyChatsSuccess(chats) {
  return {
    type: FETCH_COMPANY_CHATS_SUCCESS,
    chats,
  };
}

export function fetchCompanyChatsFailed(err) {
  return {
    type: FETCH_COMPANY_CHATS_FAILED,
    err,
  };
}

export function addCompanyMessage(companyId, details, tempId) {
  return {
    type: ADD_COMPANY_MESSAGE,
    details,
    companyId,
    tempId,
  };
}

export function addCompanyMessageSuccess(chat, tempId) {
  return {
    type: ADD_COMPANY_MESSAGE_SUCCESS,
    chat,
    tempId,
  };
}

export function addCompanyMessageFailed(err) {
  return {
    type: ADD_COMPANY_MESSAGE_FAILED,
    err,
  };
}

export function editMessage(messageId, details, id, actionType) {
  return {
    type: EDIT_MESSAGE,
    messageId,
    details,
    id,
    actionType,
  };
}

export function editMessageSuccess(message) {
  return {
    type: EDIT_MESSAGE_SUCCESS,
    message,
  };
}

export function editMessageFailed(err) {
  return {
    type: EDIT_MESSAGE_FAILED,
    err,
  };
}

export function deleteMessage(messageId, actionType) {
  return {
    type: DELETE_MESSAGE,
    messageId,
    actionType,
  };
}

export function deleteMessageSuccess(message) {
  return {
    type: DELETE_MESSAGE_SUCCESS,
    message,
  };
}

export function deleteMessageFailed(err) {
  return {
    type: DELETE_MESSAGE_FAILED,
    err,
  };
}

export function fetchFolderChanges(folderId) {
  return {
    type: FETCH_FOLDER_CHANGES,
    folderId,
  };
}

export function fetchFolderChangesSuccess(history) {
  return {
    type: FETCH_FOLDER_CHANGES_SUCCESS,
    history,
  };
}

export function fetchFolderChangesFailed(err) {
  return {
    type: FETCH_FOLDER_CHANGES_FAILED,
    err,
  };
}
